import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { usePlayNext } from '../../hooks/usePlayNext';
import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useNextAsset } from '../../hooks/NextAssetProvider/NextAssetProvider';
import { useIcons } from '../../hooks/useIcons';

export const PlayNextButton: FunctionComponent<IconButtonProps> = (props) => {
  const { playNext } = usePlayNext();
  const { nextAsset } = useNextAsset();
  const { SkipNext } = useIcons();

  const handleClick = useCallback(() => {
    playNext(nextAsset!, {
      pulse: { playbackSource: 'manualNext-contextControls' },
    });
  }, [nextAsset, playNext]);

  return (
    <IconButton onClick={handleClick} {...props}>
      <SkipNext />
    </IconButton>
  );
};
